import React from "react";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import HomeIcon from "@mui/icons-material/Home";
import { useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { navSliceActions } from "../../store/slices/NavSlice";
import Breadcrumb from "./Breadcrumb";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import NavHistoryNode from "../../models/ui/NavHistoryNode";
import { useNavigate, useParams } from "react-router-dom";
import {
  buildURLStringFromRouteParams,
  parseInteractionRouteParams,
} from "../../models/interactions/InteractionRouteParam";

const Arrow = styled(ArrowForwardIosRoundedIcon)(({ theme }) => ({
  color: "white",
  display: "flex",
  width: "0.75em",
  fontSize: "20pt",
  alignSelf: "center",
}));

export default function Breadcrumbs() {
  const params = useParams();
  const navigate = useNavigate();

  const dispatch = useStoreDispatch();
  const navHistoryNodes = useStoreSelector((state) => state.nav.navHistory);
  const currentTab = useStoreSelector((state) => state.nav.currentTab);

  const handleNavigateBack = () => {
    // find the piece of the url which represents this breadcrumb
    // remove it, re-render SPA
    if (params.interactionPath) {
      // parse the interactionPath into pieces
      const interactionRouteParams = parseInteractionRouteParams(
        params.interactionPath,
      );
      // remove everything after that piece of URL
      interactionRouteParams.pop();
      const newURLString = buildURLStringFromRouteParams(
        interactionRouteParams,
      );
      navigate("/" + currentTab + "/" + newURLString);
    }
  };

  // Just clear out the state. Sweep it clean!
  const goHome = () => {
    dispatch(navSliceActions.clearNavHistory());
    dispatch(interactionTreeSliceActions.replaceState());
    navigate("/");
  };

  const back = () => {
    handleNavigateBack();
  };

  // prepare breadcrumbs UI
  const breadcrumbsJSX: Array<JSX.Element> = [];
  navHistoryNodes.forEach((navHistoryNode: NavHistoryNode) => {
    breadcrumbsJSX.push(
      <Breadcrumb {...navHistoryNode} key={navHistoryNode.id} />,
    );
  });

  return (
    <div style={{ backgroundColor: "rgb(17,80,142)", minHeight: "50px" }}>
      <Tooltip title="Home">
        <IconButton
          style={{
            marginTop: "4px",
            marginLeft: "3px",
            marginRight: "10px",
            fontSize: "7pt",
            fontWeight: "bold",
            display: "inline",
            float: "left",
            color: "white",
            backgroundColor: "#1976d2",
          }}
          id="basic-button"
          aria-haspopup="true"
          onClick={goHome}
        >
          <HomeIcon />
        </IconButton>
      </Tooltip>
      {/* Back Button */}

      {navHistoryNodes.length > 1 && (
        <Tooltip title="Previous Interaction">
          <IconButton
            data-testid="breadcrumbsBackButton"
            style={{
              marginTop: "4px",
              marginLeft: "3px",
              marginRight: "10px",
              fontSize: "7pt",
              fontWeight: "bold",
              display: "inline",
              float: "left",
              color: "white",
              backgroundColor: "#1976d2",
            }}
            id="basic-button"
            aria-haspopup="true"
            onClick={back}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
      )}

      <Stack style={{ marginLeft: "50px" }} direction="row" divider={<Arrow />}>
        {breadcrumbsJSX}
      </Stack>
    </div>
  );
}
